// extracted by mini-css-extract-plugin
export default {"stage":"styles_stage__1C9JJ","rotate":"styles_rotate__zBjX9","ring":"styles_ring__6C8VB","poster":"styles_poster__BFa2G"};